import MetaModel from "../../../Global/Models/Pagination/MetaModel";
import StandingGameModel from "./StandingGameModel";

export default class StandingGamesModel {
  public meta: MetaModel = new MetaModel();
  public data: StandingGameModel[] = [];
}
